import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PrivateRoute } from 'routes/PrivateRoute';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { AllDocumentsList } from 'features/Documents/AllDocumentsList';
import { LinkDocumentResource } from 'features/Documents/LinkToResource/LinkDocumentResource';
import { getDocumentToLink } from 'features/Documents/LinkToResource/documentsLink';
import { ManageCompanyRedirects } from './ManageCompanyRedirects';
import { SwitchCatchNotFound as Switch } from './SwitchCatchNotFound';
import { profilePrefix, documentId, documentLinkType } from './routes';

const DocumentsRoutes: FC<{}> = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const document = useSelector(getDocumentToLink);

  return (
    <>
      <AppMenuDrawer />
      <ManageCompanyRedirects redirectTo={profilePrefix} />
      <Switch>
        <PrivateRoute
          exact
          path={path}
          component={AllDocumentsList}
          navbar={SimpleNavBar}
          navbarTitle={t('documents.title')}
        />
        <PrivateRoute
          path={`${path}/link${documentId}${documentLinkType}`}
          component={LinkDocumentResource}
          navbar={SimpleNavBar}
          navbarTitle={document?.name}
          navbarBack
        />
      </Switch>
    </>
  );
};
/* /:resourceType */
export { DocumentsRoutes };
